import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, saveState, deleteState } from "../../providers/actions";
import { mostraAguardando, escondeAguardando } from "../../providers/actions";
import { Message } from "../Message/Message";
import { Loading } from "../Loading/Loading";
import {getMessagemErro} from "../../utils/erro";
import { Resultado } from "./Resultado";
import { ButtonBack } from "../Button/Back";
import SelectSearch from "../UI/SelectSearch/SelectSearch";
import api from "../../services/api";
import './RelatorioGerencial.css';
import DatePicker , { registerLocale }from "react-datepicker";
import pt_br from "date-fns/locale/pt-BR";
import "react-datepicker/dist/react-datepicker.css";
import { baixarArquivo } from "../../utils/downloadUtil";
import { formataData } from '../../utils/formatadorData';

import { FEDERAL, ESTADUAL, MUNICIPAL } from "../../providers/constEsferasAdministrativas";

registerLocale("pt_br", pt_br);

const mapDispatchToProps = { saveState, deleteState, exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, mostraAguardando, escondeAguardando }

const mapStateToProps = (state) => {
	return {
		user: state.usuarioStore.user,
		filters: state.filterStore,
	}
}

const tipoVisaoConsumidor = 'C';
const tipoVisaoFornecedor = 'F';
const tipoVisaoOperador = 'O';
const tipoVisaoPontoFocal = 'P';

export const RelatorioGerencial =

withRouter(

// redux
connect(
	(mapStateToProps), 
	(mapDispatchToProps)
)(

	class extends Component {

		constructor(props){
			super(props);
			this.initialState = {
				esferaAdministrativa: '',
				esferasAdministrativas: [ESTADUAL, FEDERAL, MUNICIPAL],
				orgaos: [],
				orgao: '',
				fornecedoras: [],
				fornecedora: '',
				contratos: [],
				contrato: '',
				ambiente: '',
				planos: [],
				planoConsumo: '',
				carregandoFornecedoras: false,
				resultadoPesquisa: {},
				dataInicial: '',
				dataFinal: '',
				tiposVisao: [],
				tipoVisao: tipoVisaoConsumidor,
				considerarAplicacaoMonitora: false,
				mostrarSomenteAdesoesAtivas: false,
				pesquisaExecutada : false,
				botoesHabilitados : true,
				ordenacao: 1,
			};
			this.state = this.initialState;
			this.handleInputChange = this.handleInputChange.bind(this);
			this.handleEsferaAdministrativaChange = this.handleEsferaAdministrativaChange.bind(this);
			this.handleOrgaoChange = this.handleOrgaoChange.bind(this);
			this.handleContratoChange = this.handleContratoChange.bind(this);
			this.handleAmbienteChange = this.handleAmbienteChange.bind(this);
			this.handleFornecedoraChange = this.handleFornecedoraChange.bind(this);
			this.carregarOrgaos = this.carregarOrgaos.bind(this);
			this.carregarFornecedoras = this.carregarFornecedoras.bind(this);
			this.pesquisar = this.pesquisar.bind(this);
			this.executaPesquisaGerencial = this.executaPesquisaGerencial.bind(this);
			this.onChangePage = this.onChangePage.bind(this);
			this.onOrderChange = this.onOrderChange.bind(this);
			this.limparPesquisa = this.limparPesquisa.bind(this);
			this.mostraRelatorioGerencialCSV = this.mostraRelatorioGerencialCSV.bind(this);
			this.mostraRelatorioGerencialPDF = this.mostraRelatorioGerencialPDF.bind(this);
			this.handleTipoVisaoChange = this.handleTipoVisaoChange.bind(this);
		}

		render() {
			return (
				<main id="content" className="page-content p-3">
					<Message />
					<Loading />
					<div style={{margin: "10px"}}>
						<h1>Relatório Gerencial</h1>
					</div>
					<div className="div-form">
						{this.renderForm()}
					</div>
				</main>
			);
		}

		componentDidMount(){
			this.props.limpaMensagem();
			let tipoVisao = this.state.tipoVisao;
			const esferaAdministrativa = this.state.esferaAdministrativa;
			if(this.props.user.isFornecedor === true || this.props.user.isOperador === true){
				tipoVisao = tipoVisaoFornecedor;
				if(this.props.user.isOperador === true ){
					tipoVisao = tipoVisaoOperador;
				}

				api.get('/api/consumo/tipos-visao-relatorio')
				.then(response => { 
					const tiposVisao = response.data.filter(tv => tv.codigo !== tipoVisaoPontoFocal);
					this.setState({
						tipoVisao,
						tiposVisao,
					}) 
				})
				.catch(erro => {
					console.log("Não foi possível recuperar os tipos de visão para o relatório " + erro)
					this.props.exibeMensagemErro("Erro durante o carregamento da página")
				});
			}

			this.carregarOrgaos(tipoVisao, esferaAdministrativa);

			api.get('/api/contrato/tipo/A')
			.then(response => { 
				const contratos = response.data;
				this.setState(
					{
						contratos,
					}
				) 
			})
			.catch(erro => {
				console.log("Não foi possível recuperar os contratos " + erro)
				this.props.exibeMensagemErro("Erro durante o carregamento da página")
			});

			this.carregarFornecedoras(tipoVisao, this.state.orgao, this.state.contrato, this.state.ambiente);

			if (!this.props.location.state?.resetSearch) {
				this.executarPesquisaAnterior();
			}
		}

		renderForm() {
			const { resultadoPesquisa, pesquisaExecutada } = this.state;
			const exibeBotoes = resultadoPesquisa.content && resultadoPesquisa.content.length > 0;

			const user = this.props.user;
			const tipoVisao = this.state.tipoVisao;
			const exibeComboOrgao = user && (user.isAdministrador === true || user.isMantenedor === true || (user.isFornecedor === true && tipoVisao === tipoVisaoFornecedor) || (user.isOperador === true && tipoVisao === tipoVisaoOperador));
			const exibeConsiderarAplicacaoMonitora = user && (user.isAdministrador === true || user.isMantenedor === true);

			return(
				<div className="container-fluid">
					<div className="br-form">
						{user && (user.isFornecedor === true || user.isOperador === true) &&
								<div className="row">
									<div className="col-sm-2">
										<div className="field">
											<div className="input">
												<label htmlFor="tipoVisao">Mostrar:</label>
												<SelectSearch
													id="tipoVisao"
													name="tipoVisao"
													options={this.state.tiposVisao.map(tipoVisao => ({ value: tipoVisao.codigo, label: tipoVisao.nome}))}
													onChange={this.handleTipoVisaoChange}
													value={this.state.tipoVisao}								
												/>
											</div>
										</div>
									</div>
								</div>
							}
						<div className="row">
							{ exibeComboOrgao &&
							<>
								<div className="col-sd">
									<div className="field">
										<div className="input">
											<label>Esfera Administrativa:</label>
											<SelectSearch
												id="esferaAdministrativa"
												name="esferaAdministrativa"
												allOptionName="Todas"
												options={this.state.esferasAdministrativas.map(esfera => ({ value: esfera.codigo, label: esfera.nome }))}
												includeAllOption={true}
												onChange={this.handleEsferaAdministrativaChange}
												value={this.state.esferaAdministrativa}
											/>
										</div>
									</div>
								</div>
								<div className="col-md">
									<div className="field">
										<div className="input">
											<label >Órgão Consumidor:</label>
											<SelectSearch
												id="orgao"
												name="orgao"
												includeAllOption={true}
												options={this.state.orgaos.map(orgao => ({ value: orgao.id, label: orgao.nome}))}
												onChange={this.handleOrgaoChange}
												value={this.state.orgao}								
											/>
										</div>
									</div>
								</div>
							</>
							}
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label htmlFor="contrato">Contrato:</label>
										<SelectSearch
											id="contrato"
											name="contrato"
											includeAllOption={true}
											options={this.state.contratos.map(contrato => ({ value: contrato.id, label: `${contrato.nomeContrato} => ${formataData(contrato.inicioVigencia)} a ${formataData(contrato.fimVigencia)}`}))}
											onChange={this.handleContratoChange}
											value={this.state.contrato}
										/>
									</div>
								</div>
							</div>
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label htmlFor="ambiente">Ambiente:</label>
										<SelectSearch
											id="ambiente"
											name="ambiente"
											includeAllOption={true}
											allOptionName="Todos"
											options={[{ value: 'P', label: 'Produção' }, { value: 'H', label: 'Homologação' }]}
											onChange={this.handleAmbienteChange}
											value={this.state.ambiente}
										/>
									</div>
								</div>
							</div>
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label>API:</label>
										{this.state.fornecedoras.length > 0 &&
											<SelectSearch
												id="fornecedora"
												name="fornecedora"
												placeholder="Selecione uma opção"
												options={this.state.fornecedoras.map(fornecedora => ({ value: fornecedora.id, label: fornecedora.nome}))}
												onChange={this.handleFornecedoraChange}
												value={this.state.fornecedora}
											/>
										}
										{this.state.carregandoFornecedoras === true && 
											<button className="br-button is-secondary is-circle is-loading" type="button"/>
										}

										{this.state.carregandoFornecedoras === false && this.state.fornecedoras.length === 0 && 'Não há APIs para serem selecionadas.'}
									</div>
								</div>
							</div>
							<div className="col-md">
								<div className="field">
									<div className="input">
									{this.state.planos.length > 0 &&
									<label htmlFor="plano">Plano de Consumo:</label>
									}									
									{this.state.planos.length > 0 &&
										<SelectSearch
											id="planoConsumo"
											name="planoConsumo"
											includeAllOption={true}
											options={this.state.planos.map(plano => ({ value: plano.idPlano, label: plano.descricaoPlano}))}
											onChange={this.handleInputChange}
											value={this.state.planoConsumo}				
										/>
										}
									</div>
								</div>
							</div>
						</div>

						<div className="row">
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label>Data Inicial:</label>
										<DatePicker locale="pt_br" dateFormat="dd/MM/yyyy" selected={this.state.dataInicial} onChange={data => {this.setState({dataInicial: data})}} />
									</div>
								</div>
							</div>

							<div className="col-md">
								<div className="field">
									<div className="input">
										<label>Data Final:</label>
										<DatePicker locale="pt_br" dateFormat="dd/MM/yyyy" selected={this.state.dataFinal} onChange={data => {this.setState({dataFinal: data})}} />
									</div>
								</div>
							</div>
						</div>

						
						<div className="row">
							{ exibeConsiderarAplicacaoMonitora &&
								<div className="col-md">
									<div className="check">
										<div className="input">
											<input type="checkbox" name="considerarAplicacaoMonitora" checked={this.state.considerarAplicacaoMonitora} onChange={this.handleInputChange} />
											<label>Mostrar consumo das aplicações de monitoração</label>
										</div>
									</div>
								</div>
							}

							<div className="col-md">
								<div className="check">
										<div className="input">
											<input type="checkbox" name="mostrarSomenteAdesoesAtivas" checked={this.state.mostrarSomenteAdesoesAtivas} onChange={this.handleInputChange} />
											<label>Mostrar somente adesões ativas</label>
										</div>
									</div>
							</div>
						</div>

						<div className="actions-button">
							<div className="actions justify-content-start">
								<button type="button" className="button is-primary" onClick={this.pesquisar} disabled={!this.state.botoesHabilitados}>Pesquisar</button>
								{exibeBotoes === true &&	<button type="button" className="button is-secondary" onClick={this.mostraRelatorioGerencialPDF} disabled={!this.state.botoesHabilitados}>Relatório PDF</button>}
								{exibeBotoes === true &&	<button type="button" className="button is-secondary" onClick={this.mostraRelatorioGerencialCSV} disabled={!this.state.botoesHabilitados}>Relatório CSV</button>}
								<button type="button" className="button is-secondary" onClick={() => this.limparPesquisa()} disabled={!this.state.botoesHabilitados}>Limpar</button>
								<ButtonBack disabled={!this.state.botoesHabilitados} />
							</div>
						</div>

						<Resultado resultadoPesquisa={resultadoPesquisa} pesquisaExecutada={pesquisaExecutada} onChangePage={this.onChangePage} 
							ordenacao={this.state.ordenacao} onOrderChange={this.onOrderChange} 
							botoesHabilitados={this.state.botoesHabilitados}/>

					</div>
				</div>
			);
		}

		validaFormulario(){
			let mensagens = [];
			const {fornecedora, dataInicial, dataFinal} = this.state;

			if(!fornecedora){
				mensagens.push({mensagem: "API é obrigatório."})
			}

			if(dataInicial && dataFinal && dataInicial > dataFinal){
				mensagens.push({mensagem: "A data inicial deve ser menor ou igual à data final"})
			}
			
			if(mensagens.length > 0){
				this.props.exibeMensagemErro("Não foi possível realizar a operação porque há inconsistências nos campos informados:", mensagens)
				throw new Error("Formulário não preenchido corretamente.");
			}
		}

		handleInputChange(evento){
			const target = evento.target;
			const nome = target.name;
			const valor = target.type === 'checkbox' ? target.checked : target.value;
			this.setState({[nome]: valor});
		}

		handleTipoVisaoChange(evento){
			const tipoVisao =  evento.target.value;
			const orgao = "";
			const contrato = "";
			let fornecedoras = [];

			this.setState({
				tipoVisao,
				fornecedoras,
				fornecedora: "",
				orgao,
				contrato,
				planos: [],
				planoConsumo: "",
			});
			this.carregarOrgaos(tipoVisao, this.state.esferaAdministrativa);
			this.carregarFornecedoras(tipoVisao, orgao, contrato, this.state.ambiente);
		}

		handleOrgaoChange(evento){
			const idOrgao =  evento.target.value;
			const idTipoVisao = this.state.tipoVisao;
			const idContrato = this.state.contrato;

			this.setState({
				consumidora: "",
				fornecedora: "",
				planos: [],
				planoConsumo: '',
				orgao: idOrgao,
			});

			this.carregarFornecedoras(idTipoVisao, idOrgao, idContrato, this.state.ambiente);
		}

		handleEsferaAdministrativaChange(evento){
			const esferaAdministrativa =  evento.target.value;
			const idTipoVisao = this.state.tipoVisao;

			this.setState({
				orgao: "",
				fornecedora: "",
				planos: [],
				planoConsumo: '',
				esferaAdministrativa,
			});

			this.carregarOrgaos(idTipoVisao, esferaAdministrativa);
		}

		handleContratoChange(evento){
			const contrato =  evento.target.value;
			const tipoVisao = this.state.tipoVisao;
			const orgao = this.state.orgao;

			this.setState({
				fornecedora: "",
				planos: [],
				planoConsumo: '',
				contrato,
			});

			this.carregarFornecedoras(tipoVisao, orgao, contrato, this.state.ambiente);
		}

		handleAmbienteChange(evento){
			const ambiente =  evento.target.value;
			const tipoVisao = this.state.tipoVisao;
			const orgao = this.state.orgao;
			const contrato = this.state.contrato;

			this.setState({
				fornecedora: "",
				planos: [],
				planoConsumo: '',
				ambiente,
			});

			this.carregarFornecedoras(tipoVisao, orgao, contrato, ambiente);
		}

		carregarOrgaos(tipoVisao, esferaAdministrativa) {
			if(this.props.user.isAdministrador === false && this.props.user.isMantenedor === false
				&& (this.props.user.isFornecedor === false || tipoVisao !== tipoVisaoFornecedor)  
				&& (this.props.user.isOperador === false || tipoVisao !== tipoVisaoOperador))	{
				return;
			}

			api.get(`/api/orgao/consumidores/perfil-usuario?tipoVisao=${tipoVisao}&esferaAdministrativa=${esferaAdministrativa}`)
					.then(response => { this.setState({orgaos: response.data}) })
					.catch(erro => {
						console.log("Não foi possível recuperar órgãos consumidores " + erro)
						this.props.exibeMensagemErro("Erro durante o carregamento da página")
					});
		}

		carregarFornecedoras(idTipoVisao, idOrgao, idContrato, ambiente) {
			this.setState(
				{
					carregandoFornecedoras : true
				}
			);
			api.get(`/api/aplicacao-fornecedora/tipo-visao/${idTipoVisao}/orgao-consumidor?idOrgaoConsumidor=${idOrgao}&idContrato=${idContrato}&ambiente=${ambiente || ''}`)
			.then(response => { 
				const fornecedoras = response.data;
				this.setState(
					{
						fornecedoras,
						carregandoFornecedoras : false,
					}
				)
			 })
			.catch(erro => {
				this.setState({carregandoFornecedoras : false});
				console.log("Não foi possível recuperar as aplicações fornecedoras " + erro)
				this.props.exibeMensagemErro("Erro durante o carregamento da página")
			});
		}

		executarPesquisaAnterior() {
			const lastState = this.props.filters[this.props.location.pathname];

			this.setState({
				...this.initialState,
				...lastState,
				pesquisaExecutada: false,
				resultadoPesquisa: {}
			}, () => {
				if (lastState) {
					const lastPage = lastState ? lastState?.resultadoPesquisa?.number : 0;
					const lastOrder = lastState ? lastState?.ordenacao : 1;
					this.executaPesquisaGerencial(lastPage, lastOrder);
				}
			});
		}

		pesquisar (e){
			this.props.limpaMensagem();

			try{
				this.validaFormulario();
			}catch(erroValidacao){
				e.preventDefault();
				return;
			}
			this.executaPesquisaGerencial(0, 1);
		}

		onChangePage(pagina) {
			this.executaPesquisaGerencial(pagina, this.state.ordenacao);
		}

		onOrderChange(ordem) {
			let ordenacao = ordem;
			if (Math.abs(ordenacao) === this.state.ordenacao){
				ordenacao = ordenacao * -1;
			}
			this.setState({ordenacao});
			this.executaPesquisaGerencial(0, ordenacao);
		}

		executaPesquisaGerencial(pagina, ordenacao){

			const {fornecedora, orgao, esferaAdministrativa, contrato, ambiente, dataInicial, dataFinal, planoConsumo, tipoVisao, considerarAplicacaoMonitora, mostrarSomenteAdesoesAtivas } = this.state;
			const criterioPesquisa = {fornecedora, orgao, esferaAdministrativa, contrato, ambiente, dataInicial, dataFinal, planoConsumo, tipoVisao, considerarAplicacaoMonitora, mostrarSomenteAdesoesAtivas, pagina, ordenacao };

			let url;
			url = '/api/gerencial/paginado';

			const options = {
				method: 'post',
				url,
				data: criterioPesquisa
			}

			this.props.mostraAguardando();
			this.setState({botoesHabilitados : false, ordenacao});
			api(options)
				.then(response => { 
					this.setState({
						resultadoPesquisa: response.data,
						pesquisaExecutada : true,
					}, () => {
						this.props.saveState(this.state, this.props.location.pathname);
					}) 
				})
				.catch(erro => {
					const msg = getMessagemErro("Não foi possível recuperar os dados gerenciais ", erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.then(() => {
					this.props.escondeAguardando();
					this.setState({botoesHabilitados : true});
				});
		}

		mostraRelatorioGerencialCSV(e){
			this.mostraRelatorioGerencial(e, 'csv');
		}

		mostraRelatorioGerencialPDF(e){
			this.mostraRelatorioGerencial(e, 'pdf');
		}

		mostraRelatorioGerencial(e, tipo){
			try{
				this.validaFormulario();
			}catch(erroValidacao){
				e.preventDefault();
				return;
			}

			const {fornecedora, orgao, esferaAdministrativa, contrato, ambiente, dataInicial, dataFinal, planoConsumo, tipoVisao, considerarAplicacaoMonitora, mostrarSomenteAdesoesAtivas } = this.state;
			const criterioPesquisa = {fornecedora, orgao, esferaAdministrativa, contrato, ambiente, dataInicial, dataFinal, planoConsumo, tipoVisao, considerarAplicacaoMonitora, mostrarSomenteAdesoesAtivas};
			const url = `/api/gerencial/${tipo}`;

			const options = {
				method: 'post',
				url,
				data: criterioPesquisa,
				responseType: 'arraybuffer'
			}

			this.props.mostraAguardando();
			this.setState({botoesHabilitados : false});

			api(options)
				.then((response) => {
					baixarArquivo(new Blob([response.data]), `RelatorioGerencial.${tipo}`);
				})				
				.catch(response => {
					const erro = {data: JSON.parse(Buffer.from(response.data).toString('utf8'))};
					const mensagemInicial = 'Não foi possível recuperar o relatório gerencial';
					const msg = getMessagemErro(mensagemInicial, erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.then(() => {
					this.props.escondeAguardando();
					this.setState({botoesHabilitados : true});
				});
		}

		limparPesquisa(){
			this.props.limpaMensagem();
			let tipoVisao = tipoVisaoConsumidor;

			if(this.props.user.isFornecedor === true){
				tipoVisao = tipoVisaoFornecedor;
			} 
			if(this.props.user.isOperador === true){
				tipoVisao = tipoVisaoOperador;
			}
			const orgao = '';
			const esferaAdministrativa = '';
			const contrato = '';
			const ambiente = '';
			this.setState({
				orgao,
				esferaAdministrativa,
				fornecedora: '',
				contrato,
				ambiente,
				planos: [],
				tipoVisao,
				resultadoPesquisa: {},
				pesquisaExecutada : false,
				dataInicial: '',
				dataFinal: '',
				planoConsumo: '',
				considerarAplicacaoMonitora: '',
				mostrarSomenteAdesoesAtivas: false,
				ordenacao: 1,
			}, () => {
				this.props.deleteState(this.state, this.props.location.pathname);
			});
			this.carregarOrgaos(tipoVisao, esferaAdministrativa);
			this.carregarFornecedoras(tipoVisao, orgao, contrato, ambiente);
		}

		handleFornecedoraChange(evento){
			const target = evento.target;
			const nome = target.name;
			const valor = target.value;
			this.setState({[nome]: valor});
			this.props.limpaMensagem();
			const idFornecedora =  evento.target.value;
			this.setState({
				planos : [],
				planoConsumo: "",
			});
			this.carregaPlanosFornecedora(idFornecedora);
		}

		carregaPlanosFornecedora(idFornecedora){
			if(idFornecedora && idFornecedora !== "0"){
				api.get(`/api/plano/alocados/tipo-visao/${this.state.tipoVisao}/aplicacao-fornecedora/${idFornecedora}?idOrgaoConsumidor=${this.state.orgao}`)
				.then(response => { 
					this.setState(
						{
							planos: response.data
						}
					);
				})
				.catch(erro => {
					console.log("Não foi possível recuperar os planos associados à API " + JSON.stringify(erro));
					this.props.exibeMensagemErro("Erro durante o carregamento dos planos das api's.")
				});
			}
		}

	}

) // redux
); // router